import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Grid, Navigation } from 'swiper/modules';
import DefaultProduct from './DefaultProduct';
import WideProduct from './WideProduct';
import { useLanguage } from '../../hooks/useLanguage';

function ProductSection({ 
    title, 
    products, 
    swiperOptions,
    showTabs = false,
    categoryList = [],
    activeTab = '',
    onTabClick,
    sectionId,
    headerRight = null,
    beforeContent = null,
    afterContent = null,
    showMoreButton = true,
    onMoreClick,
    useSwiper = true,
    packageFlag = 'N'
}) {
    // 기존 반응형 상태 (768px 기준)
    const [isMobile, setIsMobile] = useState(false);
    // 새로운 반응형 상태 (1280px 기준)
    const [isTablet, setIsTablet] = useState(false);

    // 반응형 처리
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setIsTablet(window.innerWidth < 1280);
        };
        
        handleResize();
        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // 현재 섹션이 뷰포트에 있는지 확인하는 함수
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 현재 섹션이 화면에 보일 때 해당하는 dot 활성화
                        const dots = document.querySelectorAll('.section_area_dot .dot');
                        const sectionIds = [
                            'main-banner',
                            'credits-section',
                            'new-arrival',
                            'cinema-camera',
                            'cinema-lens',
                            'etc-section',
                            'acc-section'
                        ];
                        
                        const currentIndex = sectionIds.indexOf(sectionId);
                        if (currentIndex !== -1 && dots[currentIndex]) {
                            dots.forEach(dot => dot.classList.remove('active'));
                            dots[currentIndex].classList.add('active');
                        }
                    }
                });
            },
            {
                threshold: 0.5  // 섹션이 50% 이상 보일 때 활성화
            }
        );
        const section = document.getElementById(sectionId);
        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };
    }, [sectionId]);

    const { t } = useLanguage();

    return (
        <div className="main_prod_list" id={sectionId}>
            <div className="inner">
                
                <div className="credit_title_wrap">
                    <div className="credit_title">{title}</div>
                    {headerRight}
                    {showMoreButton && (
                        <button 
                            className="more_text_btn flex-center-2"
                            onClick={() => onMoreClick && onMoreClick(sectionId)}
                        >
                            {t('see_more')}
                        </button>
                    )}
                </div>

                {showTabs && (
                    <div className="round_tab">
                        <ul className="tab_list">
                            <li 
                                className={`tab_item ${activeTab === 'all' ? 'active' : ''}`}
                                onClick={() => onTabClick('all')}
                            >
                                <button className="flex-center-4 flex-justify-center">
                                    All
                                </button>
                            </li>
                            {categoryList?.map((category, index) => (
                                <li
                                    key={index}
                                    className={`tab_item ${activeTab === category?.category_seq ? 'active' : ''}`}
                                    onClick={() => onTabClick(category?.category_seq)}
                                >
                                    <button className="flex-center-4 flex-justify-center">
                                        {category?.category_name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {beforeContent}

                {products && products.length > 0 ? (
                    useSwiper ? (
                        <div className="swiper_parent">
                            {products && products.length > 0 ? (
                                <>
                                    <Swiper
                                        {...swiperOptions}
                            
                                        {...(isMobile 
                                            ? { slidesPerView: 2, slidesPerGroup: 2 }   // ✅ 모바일일 때 2개씩 보기 + 2개씩 이동
                                            : { slidesPerView: 5, slidesPerGroup: 5 }   // ✅ PC일 때 5개씩 보기 + 5개씩 이동
                                        )}
                                        modules={[Pagination, Grid, Navigation]}
                                        navigation={{
                                                prevEl: `#${sectionId}-prev`,
                                                nextEl: `#${sectionId}-next`,
                                            }} 
                                            on = {{
                                            activeIndexChange : function() {
                                                if (this.realIndex === 0) {
                                                this.allowSlidePrev = false;
                                                } else {
                                                this.allowSlidePrev = true;
                                                }
                                            },
                                        }}
                                        className="main_prod_swiper"
                                    >
                                        {products.map((product, index) => (
                                            <SwiperSlide key={index} style={{padding:"3px"}}>
                                                <DefaultProduct product={product} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                    {!isMobile && (
                                        <>
                                            <div id={`${sectionId}-prev`} className="swiper-button-prev" />
                                            <div id={`${sectionId}-next`} className="swiper-button-next" />
                                        </>
                                    )}
                                </>
                            ) : (
                                <div className="no-data-message" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                                    {t('no_data')}
                                </div>
                            )}
                        </div>
                    ) : (
                        <>
                            {packageFlag === 'Y' ? (
                                <div className={isTablet ? '' : 'products-grid-two'}>
                                    {products.map((product, index) => (
                                        <div key={index} className="product-item">
                                            <WideProduct product={product} />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="products-grid">
                                    {products.map((product, index) => (
                                        <div key={index} className="product-item">
                                            <DefaultProduct product={product} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )
                ) 
                : (
                    <div className="no_result-1">
                        {/* {t('no_data')} */}
                    </div>
                )
                }

                {/* 데이터가 없을 때 보이지 않게  */}
                {afterContent}
            </div>
        </div>
    );
}

export default ProductSection;
